import { Dimensions, Platform, StyleSheet, View } from "react-native";
import React, { useEffect, useRef } from "react";
import { Text } from "../../../components/Themed";
import InputText from "../../../components/InputText";
import { useForm } from "react-hook-form";
import Colors from "../../../constants/Colors";
import GoogleAutocomplete from "../../../components/GoogleAutocomplete";

const { width } = Dimensions.get("window");

interface QuestionInputProps {
  question: string;
  details: string;
  inputName: string;
  inputLabel: string;
  control: any;
  errors: any;
  useGoogle?: boolean;
  setValue?: (name: string, value: string) => void;
  padding?: number;
}

const QuestionInput: React.FC<QuestionInputProps> = ({
  question,
  details,
  inputName,
  inputLabel,
  control,
  errors,
  useGoogle = false,
  setValue,
  padding = 40,
}) => {
  const googleAutoComplete = useRef();

  const autocompletePress = (data: any, details: any) => {
    setValue && setValue(inputName, details.description);
  };

  return (
    <View style={[styles.page, { paddingHorizontal: padding / 2, paddingTop: padding / 2 }]}>
      <View style={styles.container}>
        <Text size={26} lineHeight={28} style={styles.questionText}>
          {question}
        </Text>
        {details ? (
          <Text size={20} lineHeight={28} style={styles.detailsText}>
            {details}
          </Text>
        ) : null}
        {useGoogle ? (
          <View
            style={{
              flexDirection: "column",
              width: "100%",
              marginHorizontal: 20,
            }}
          >
            <Text
              style={{
                fontSize: 16,
                paddingBottom: 4,
                color: Colors.nuetral_grey_700,
              }}
            >
              What is your home address?
            </Text>
            <GoogleAutocomplete
              ref={googleAutoComplete}
              onLocationSelected={autocompletePress}
              placeholder={""}
              leftIcon={false}
              rightIcon={false}
              queryType="address"
            />
          </View>
        ) : (
          <InputText
            control={control}
            label={inputLabel}
            name={inputName}
            errors={errors}
          />
        )}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  page: {
    width: "100%",
    alignItems: "center",
  },
  container: {
    alignItems: "center",
    width: "100%",
    maxWidth: 500,
  },
  questionText: {
    marginBottom: 20,
    textAlign: "center",
    color: Colors.nuetral_grey_700,
  },
  detailsText: {
    textAlign: "center",
    color: Colors.nuetral_grey_700,
    marginBottom: 80,
  },
  infoText: {
    fontSize: 14,
    lineHeight: 20,
    color: Colors.nuetral_grey_600,
    marginTop: -20,
  },
});

export default QuestionInput;
